<template>
  <div
    v-if="!hideSaleBanner"
    class="sale-banner"
    @click="goPro"
    :style="{ top, position }"
  >
    <img
      class="header"
      v-show="thumbnail_url"
      :src="thumbnail_url"
      alt="thumbnail"
    />
    <div class="description">
      <span class="description-content">
        <strong>{{ descriptor }}</strong>
        &nbsp;WITH CODE:&nbsp;
        <strong>{{ promoCode }}</strong>
      </span>
      <span class="bull">&bull;</span>
      <span class="detail">{{ details }}</span>
      <img
        src="@/assets/images/icons/close-white.svg"
        alt="close"
        class="close"
        @click="close"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import moment from "moment-timezone"

export default {
  props: {
    top: {
      type: String,
      default: "0",
    },
    position: {
      type: String,
      default: "relative",
    },
  },
  data () {
    return {
      currentTime: moment.utc(),
    }
  },
  computed: {
    ...mapGetters("Util", ["saleBanner", "hideSaleBanner"]),
    promoCode () {
      return this.saleBanner.promo_code.code
    },
    descriptor () {
      return this.saleBanner.promo_code.descriptor
    },
    details () {
      try {
        const activeUntilTime = moment
          .utc(this.saleBanner.active_until.date)
          .subtract(1, "seconds")
        const pstTime = moment
          .tz(activeUntilTime, "America/Los_Angeles")
          .format("MM/DD/YY")
        return `OFFER ENDS ${pstTime}`
      } catch (error) {
        return ""
      }
    },
    thumbnail_url () {
      return this.saleBanner.thumbnail_url
    },
  },
  methods: {
    ...mapActions("Util", ["loadSaleBanner"]),
    ...mapMutations("Util", ["setClosedSaleBanner", "setHideGoProBanner"]),
    close () {
      try {
        this.setClosedSaleBanner(true)
        if (this.saleBanner) {
          const activeUntilTime = moment.utc(this.saleBanner.active_until.date)
          const storageKey = `${
            this.saleBanner.promo_code.code
          }${activeUntilTime.format("YYYY")}`
          window.localStorage.setItem(storageKey, true)
        }
        this.setHideGoProBanner(true)
        window.localStorage.setItem("hide-main-navigation-cta-banner", true)
      } catch (error) {
        console.error(error)
      }
    },
    goPro (e) {
      if (e.target.className !== "close") {
        window.location.href = "/store/subscriptions"
        this.trackAnalyticsEvent("Clicked Banner Go Pro")
        this.trackAnalyticsEvent("Click Sale banner")
      }
    },
    getCurrentTime () {
      setInterval(() => {
        this.currentTime = moment.utc()
      }, 1000)
    },
  },
  created () {
    this.loadSaleBanner()
  },
  mounted () {
    this.getCurrentTime()
  },
  destroyed () {
    clearInterval(this.getCurrentTime)
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.sale-banner {
  width: 100%;
  height: 5.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #333333;
  z-index: 8;
  cursor: pointer;
  .header {
    height: 4.9rem;
    object-fit: cover;
    object-position: center;
    @include phone-down {
      height: 3.5rem;
    }
  }
  .description {
    font-family: Proxima Nova;
    font-style: normal;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 100%;
    color: #ffffff;
    height: 3.5rem;
    display: flex;
    align-items: center;
    @include phone-down {
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      // border-left: 1px solid #ffffff;
      padding-left: 1.3rem;
      margin-left: 1.3rem;
      max-width: 90%;
      @include phone-small {
        padding-left: 0.5rem;
        margin-left: 0.5rem;
        margin-right: 1rem;
      }
    }
    .description-content {
      height: 3.5rem;
      // border-left: 1px solid #ffffff;
      // border-right: 1px solid #ffffff;
      display: flex;
      align-items: center;
      padding: 0 2.5rem;
      margin-left: 2.5rem;
      @include phone-down {
        font-size: 1.2rem;
        line-height: 125.6%;
        border: none;
        margin: 0;
        padding: 0;
      }
      // @include phone-small {
      //   font-size: 11px;
      // }
      strong {
        color: #ffc85f;
        font-style: normal;
        font-weight: 600;
        text-transform: uppercase;
      }
    }
  }
  .bull {
    @include tablet-down {
      display: none;
    }
  }
  .detail {
    margin-left: 2.5rem;
    font-family: Proxima Nova;
    font-style: normal;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 89.6%;
    color: #ffffff;
    @include phone-down {
      font-size: 1.2rem;
      line-height: 125.6%;
    }
  }
  .close {
    position: absolute;
    right: 1.6rem;
    top: 1.6rem;
    cursor: pointer;
    padding: 0.5rem;
    opacity: 0.6;
    &:hover {
      opacity: 1;
    }
    @include phone-small {
      right: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/banner/SaleBanner.vue